import { createApi } from '@shared/redux/createApi';

const tags = {
  questionare: 'questionare',
};

const buildQuestionareFormData = (data) => {
  const formData = new FormData();

  if (data.sk !== undefined && data.sk !== null && data.sk !== '') {
    formData.append('sk', data.sk);
  }
  if (data.title !== undefined) formData.append('title', data.title);
  if (data.description !== undefined) formData.append('description', data.description);
  if (data.answer !== undefined) formData.append('answer', data.answer);
  if (data.options !== undefined) {
    formData.append('options', JSON.stringify(data.options || []));
  }
  if (data.image instanceof File || data.image instanceof Blob) {
    formData.append('image', data.image, data.image.name || 'image.png');
  }
  if (data.dark_image instanceof File || data.dark_image instanceof Blob) {
    formData.append('dark_image', data.dark_image, data.dark_image.name || 'dark_image.png');
  }

  return formData;
};

export const questionareApi = createApi({
  reducerPath: 'questionareApi',
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    getQuestionareList: builder.query({
      query: () => ({
        url: '/user/questionare/v2',
        method: 'get',
      }),
      transformResponse: (response) => ({
        list: response || [],
      }),
      providesTags: [tags.questionare],
    }),
    createQuestionare: builder.mutation({
      queryFn: async (data, _queryApi, _extraOptions, baseQuery) => {
        const formData = buildQuestionareFormData(data);
        return baseQuery({ url: '/user/questionare/create', method: 'post', body: formData });
      },
      invalidatesTags: [tags.questionare],
    }),
    updateQuestionare: builder.mutation({
      queryFn: async (data, _queryApi, _extraOptions, baseQuery) => {
        const formData = buildQuestionareFormData(data);
        return baseQuery({ url: '/user/questionare/update', method: 'post', body: formData });
      },
      invalidatesTags: [tags.questionare],
    }),
    deleteQuestionare: builder.mutation({
      query: (sk) => ({
        url: `/user/questionare/delete?sk=${encodeURIComponent(sk)}`,
        method: 'delete',
      }),
      invalidatesTags: [tags.questionare],
    }),
  }),
});

export const {
  useGetQuestionareListQuery,
  useCreateQuestionareMutation,
  useUpdateQuestionareMutation,
  useDeleteQuestionareMutation,
} = questionareApi;
